"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewBackedAppResourceIdError = void 0;
exports.viewBackedAppResourceId = viewBackedAppResourceId;
exports.parseViewBackedAppResourceId = parseViewBackedAppResourceId;
class ViewBackedAppResourceIdError extends Error {
    constructor(message, details) {
        super(message);
        this.details = details;
        this.name = 'ViewBackedAppResourceIdError';
    }
}
exports.ViewBackedAppResourceIdError = ViewBackedAppResourceIdError;
function viewBackedAppResourceId(descriptor, docId, databaseId, viewId) {
    return `${descriptor.resourcePrefix}${encodeURIComponent(requiredResourceSegment(descriptor, docId, 'docId'))}:${encodeURIComponent(requiredResourceSegment(descriptor, databaseId, 'databaseId'))}:${encodeURIComponent(requiredResourceSegment(descriptor, viewId, 'viewId'))}`;
}
function parseViewBackedAppResourceId(descriptor, resourceId) {
    if (!resourceId.startsWith(descriptor.resourcePrefix)) {
        throwInvalidResourceId(descriptor, resourceId);
    }
    const raw = resourceId.slice(descriptor.resourcePrefix.length);
    const [docId, databaseId, viewId, extra] = decodeSegments(descriptor, resourceId, raw);
    if (!docId || !databaseId || !viewId || extra !== undefined) {
        throwInvalidResourceId(descriptor, resourceId);
    }
    return { databaseId, docId, viewId };
}
function decodeSegments(descriptor, resourceId, raw) {
    try {
        return raw.split(':').map(decodeURIComponent);
    }
    catch {
        throwInvalidResourceId(descriptor, resourceId);
    }
}
function throwInvalidResourceId(descriptor, resourceId) {
    throw new ViewBackedAppResourceIdError(`Invalid ${resourceIdLabel(descriptor)}`, { resourceId, resourceKind: descriptor.appKind });
}
function requiredResourceSegment(descriptor, value, label) {
    const trimmed = value?.trim();
    if (!trimmed) {
        throw new ViewBackedAppResourceIdError(`${requiredSegmentLabel(descriptor)} requires ${label}`, { label, resourceKind: descriptor.appKind });
    }
    return trimmed;
}
function resourceIdLabel(descriptor) {
    return descriptor.resourceIdLabel ?? `${descriptor.appKind} resource id`;
}
function requiredSegmentLabel(descriptor) {
    return descriptor.requiredSegmentLabel ?? resourceIdLabel(descriptor);
}
